import { Can } from "../../../../../casl/Can";
import { AppAvatar, AppBox, AppIconButton, AppPaper, AppTitle } from "../../../../../commons/components";
import IconPersonDelete from "../../../../../commons/components/icons/person-delete";
import { RolePolicyActionEnum } from "../../../../../commons/enums/role-policy-action.enum";
import { IFootballTeamCoach } from "../../../../../commons/models/football/interface/i-football-team-coach";
import { toTitleCase } from "../../../../../commons/utilities/string-utils";
import { useAppSelector } from "../../../../../hooks/app";
import { ManageFootballTeam } from "../../../../../commons/models/football/admin/manage-football-team";

interface CoachCardProps {
  withShadow?: boolean;
  coachInfo: IFootballTeamCoach;
  onCoachRemove: (coach: IFootballTeamCoach) => void;
}

export default function TeamCoachCard({ coachInfo, withShadow, onCoachRemove }: CoachCardProps) {
  const { teamInfo } = useAppSelector((state) => state.footballManageTeam);
  return (
    <AppPaper padding="xs" shadow={withShadow ? "xs" : "none"}>
      <AppBox justifyContent="space-between" alignItems="center">
        <AppBox gap="xs" alignItems="center">
          <AppAvatar username={coachInfo.fullName || ""} src={coachInfo.avatar || ""} size="md" />
          <AppBox flexDirection="column">
            <AppBox alignItems="center" gap="2xs">
              <AppTitle as="h6">{toTitleCase(coachInfo.fullName)}</AppTitle>
            </AppBox>
          </AppBox>
        </AppBox>
        <Can I={RolePolicyActionEnum.UPDATE} this={new ManageFootballTeam(teamInfo)}>
          <AppIconButton
            variant="light"
            color="danger"
            onClick={() => {
              onCoachRemove(coachInfo);
            }}
            icon={<IconPersonDelete />}
          />
        </Can>
      </AppBox>
    </AppPaper>
  );
}
